import { Injectable } from '@angular/core';
import SafeUrlAssembler from 'safe-url-assembler';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../core/services/http/http-client.service';
import { User } from '../../shared/services/user/models/user.model';
import { ApiEndpointService } from '../../core/services/api-endpoint.service';

@Injectable()
export class ManageUsersService {

  constructor(private httpClientService: HttpClientService,
    private apiEndpointService: ApiEndpointService) {
  }

  /**
   * Gets all Users.
   *
   * @returns {Observable}
   */
  public getUsers(): Observable<any> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getUsers')).toString();
    return this.httpClientService.get<any>(endpoint);
  }

  /**
   * Disable the user of the specified userid
   *
   * @param {string} userId
   * @returns {Observable<any>}
   */
  public disableUser(userId: number): Observable<any> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('disableUser'))
      .param('userId', userId)
      .toString();
    return this.httpClientService.delete<any>(endpoint);
  }

  /**
   * Updates the user against the specific userid
   *
   * @param {User} data
   * @returns {Observable<any>}
   */
  public updateUser(data: User): Observable<any> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('updateUser'))
      .param('userId', data.UserId)
      .toString();
    return this.httpClientService.put<any>(endpoint, data);
  }

  /**
   * Saves the user
   *
   * @param {User} data
   * @returns {Observable<any>}
   */
  public addUser(data: User): Observable<any> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('addUser'))
      .toString();
    return this.httpClientService.post<any>(endpoint, data);
  }

  /**
   * changes the password
   *
   * @param {string} data
   * @param {string} userId
   * @returns {Observable<any>}
   */
  public changePassword(password: string, userId: number): Observable<any> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('changePassword'))
      .param('userId', userId)
      .toString();
    const data = { Password: password };
    return this.httpClientService.put<any>(endpoint, data);
  }

}
